import React from 'react';
import { ExternalLink, Scale } from 'lucide-react';

const LAW_GO_KR_URL = 'https://www.law.go.kr';

/**
 * 법령 원문 출처 — 법제처 Open API (저작권법 제7조, API 이용약관 출처 표기)
 */
const LawSourceAttribution = ({ variant = 'full', className = '', lawDetailUrl }) => {
  const sourceUrl = lawDetailUrl || LAW_GO_KR_URL;
  if (variant === 'compact') {
    return (
      <p className={`text-xs text-gray-600 leading-relaxed ${className}`}>
        법령 원문은{' '}
        <a
          href={LAW_GO_KR_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-700 underline underline-offset-2 hover:text-blue-800"
        >
          법제처 국가법령정보센터
        </a>
        Open API를 통해 제공됩니다.
      </p>
    );
  }

  return (
    <aside
      className={`rounded-lg border border-blue-200 bg-blue-50/90 p-4 sm:p-5 ${className}`}
      role="note"
      aria-label="법령 정보 출처"
    >
      <div className="flex items-start gap-3">
        <Scale className="w-5 h-5 text-blue-700 shrink-0 mt-0.5" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-blue-900">법령 정보 출처</p>
          <div className="mt-2 flex items-center justify-between gap-3">
            <p className="text-sm text-blue-950/90 leading-snug flex-1 min-w-0">
              본 법령 정보는 <strong>법제처 국가법령정보 Open API</strong>를 통해 제공됩니다.
            </p>
            <a
              href={sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs sm:text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition-colors shadow-sm whitespace-nowrap"
              title="국가법령정보센터에서 원문 보기"
            >
              <ExternalLink className="w-3.5 h-3.5 sm:w-4 sm:h-4" aria-hidden />
              <span className="hidden sm:inline">국가법령정보센터 </span>원문 보기
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default LawSourceAttribution;
